import { render, staticRenderFns } from "./BulkAction.vue?vue&type=template&id=c4da9012&"
import script from "./BulkAction.vue?vue&type=script&lang=js&"
export * from "./BulkAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports